<div *ngIf="isMobile">
  <app-summary-mobile></app-summary-mobile>
</div>
<div *ngIf="!isMobile">
  <app-summary-desktop></app-summary-desktop>
</div>
